module.exports = __webpack_public_path__ + "img/img2.8951f120.png";